(function(){
  var LABELS={
    'Availability':'Disponibilidad',
    'Price':'Precio',
    'Type':'Tipo de producto',
    'Vendor':'Proveedor'
  };
  function translate(root){
    var r=root||document;
    r.querySelectorAll('.facets__summary-label').forEach(function(el){
      var n=el.firstChild;
      if(n&&n.nodeType===3){var t=n.textContent.trim();if(LABELS[t])n.textContent=n.textContent.replace(t,LABELS[t]);}
    });
    r.querySelectorAll(
      '.facets__summary>div>span:first-child,'+
      '.mobile-facets__summary>div>span:first-child,'+
      '.mobile-facets__close-button>span:first-of-type'
    ).forEach(function(el){
      var t=el.textContent.trim();if(LABELS[t])el.textContent=LABELS[t];
    });
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){translate(document);});
  } else {
    translate(document);
  }
  new MutationObserver(function(mutations){
    mutations.forEach(function(m){
      m.addedNodes.forEach(function(node){
        if(node.nodeType===1)translate(node);
      });
    });
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
